module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg6-8bbbda4e628ab885ee16b8efa116ce0c.jpg";